function addMultiplier() {
    var multiplierSelector = document.querySelector('.rc-option__discount.rc_widget__option__discount');
    var subscriptionPriceSelector = document.querySelector('.rc-option__price.rc_widget__price.rc_widget__price--subsave');
    if(subscriptionPriceSelector){
        var subMultiplier = subscriptionPriceSelector.getAttribute('data-price-multiplier');
        if(subMultiplier){
            return
        }else{
            if (multiplierSelector) {
                // Extract the multiplier text, remove the % sign and convert it to a number
                var multiplier = parseFloat(multiplierSelector.innerText.replace('%', ''));
                multiplier = 1 - (multiplier / 100);
                if (subscriptionPriceSelector) {
                    subscriptionPriceSelector.setAttribute('data-price-multiplier', multiplier);
                }
            }
        }
    }
}
if (window.igData) {
  setInterval(addMultiplier, 100);
} else {
  window.addEventListener('ig:ready', function() {
      setInterval(addMultiplier, 100);
  });
}